<!--单位缺陷页面-->
<template>
	<treeBody>
		<datePicker ref="datePicker" :initDate='safeRunTime' @selectDatetime="selectDate" type="dayTime"></datePicker>
		<!--左边-->
		<unitTree :autoSelectMethod="autoSelectMethod" :groupCheckAble='true' slot="tree" @checkItem="checkItem" :dataList="unitList"></unitTree>
		<!--右边-->
		<div class="rightBody" slot="body">
			<div class="buttonLine" style="margin: auto;width: 95%;margin-top: .15rem;">
				<span class="label-class">安全开始运行时间:</span>
				<iconButton style="width: 1.5rem;" icoName="wedoButton/date.png" :buttonText="nowDateText" @buttonClick="$refs.datePicker.show()"></iconButton>
				<iconButton @buttonClick='clean' buttonText='清零' icoName="wedoButton/delete.png"></iconButton>
				<iconButton @buttonClick='saveDefect' buttonText='保存' icoName="wedoButton/add.png"></iconButton>
			</div>
			<div class="defectPage" :style="backPath('/unitInfo/unitdefect_right.png')">
				<div class="defect-group">
					<span class="defect-item">
						<span>本月发现缺陷:</span><input v-model="findErrorCount" type="number" />
					</span>
					<span class="defect-item">
						<span>本月处理缺陷:</span><input v-model="processedErrorCount" type="number" />
					</span>
				</div>
				<div class="defect-group">
					<span class="defect-item">
						<span>本月计划巡检数:</span><input v-model="checkPlan" type="number" />
					</span>
					<span class="defect-item">
						<span>本月已完成巡检数:</span><input v-model="checkCompleted" type="number" />
					</span>
				</div>
				<div class="buttonLine" style="border: .01rem solid #697a98;width: 60%;margin-left: .2rem;">
					<div class="label-class" style="font-size:.15rem"> 今日工作</div>
				</div>
				<textarea class="text-class" v-model="texts"></textarea>
			</div>
		</div>
	</treeBody>
</template>

<script type="text/javascript">
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import unitTree from '@/components/module/tree/archivesDeviceTree.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
	export default {
		components: {
			treeBody,
			iconButton,
			unitTree,
			datePicker
		},
		props: [],
		data() {
			return {
				findErrorCount: '',
				processedErrorCount: '',
				checkPlan: '',
				checkCompleted: '',
				texts: "",
				safeRunTime: new Date(),
				nowEntity: undefined
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			//预获取一些数据
			this.$store.enumStore.getters.getEnumTree
		},
		destroyed() {},
		computed: {
			nowDateText() {
				return this.safeRunTime.formatByTime('-')
			},
			archivesStore() {
				return this.$store.archivesStore
			},
			unitList() {
				let data = this.$store.unitStore.getters.getUnitTree
				return isempty(data) ? [] : [data]
			},
		},
		watch: {
			nowEntity(nv, ov) {
				this.texts = ''
				this.processedErrorCount = ''
				this.findErrorCount = ''
				this.checkPlan = ''
				this.checkCompleted = ''
				if (!isempty(nv)) {
					this.query(nv)
				}
			},
		},
		methods: {
			selectDate(date) {
				this.safeRunTime = date;
				this.$refs.datePicker.hide()
			},
			autoSelectMethod(item) {
				return item.id ? true : false
			},
			checkItem(item) {
				this.nowEntity = item
			},
			saveDefect() {
				if (isempty(this.nowEntity)) {
					return
				}
				this.$api.unitApi.saveUnitInfo(this.nowEntity.id, this.safeRunTime.formatByTime('-'), this.processedErrorCount,
					this.findErrorCount, this.texts, this.checkPlan, this.checkCompleted, respon => {
						this.$dialogMethod.showMessage('修改成功!')
						this.$store.unitStore.commit("cleanUnitDefects")
						this.setValue(respon)
					})
			},
			//设置值并且添加缓存
			setValue(respon) {
				if (isempty(respon)) {
					respon = {}
				}
				if (respon) {
					this.$store.unitStore.commit("setUnitDefectById", respon)
					this.safeRunTime = respon.safeRunTime ? new Date(respon.safeRunTime) : new Date()
					this.texts = respon.texts ? respon.texts : ''
					this.processedErrorCount = respon.processedErrorCount ? respon.processedErrorCount : ''
					this.findErrorCount = respon.findErrorCount ? respon.findErrorCount : ''
					this.checkPlan = respon.checkPlan ? respon.checkPlan : ''
					this.checkCompleted = respon.checkCompleted ? respon.checkCompleted : ''

				} else {
					respon['id'] = this.nowEntity.id
					this.$store.unitStore.commit("setUnitDefectById", respon)
					this.safeRunTime = respon.safeRunTime ? new Date(respon.safeRunTime) : new Date()
					this.texts = respon.texts ? respon.texts : ''
					this.processedErrorCount = respon.processedErrorCount ? respon.processedErrorCount : ''
					this.findErrorCount = respon.findErrorCount ? respon.findErrorCount : ''
					this.checkCompleted = respon.checkCompleted ? respon.checkCompleted : ''
					this.checkPlan = respon.checkPlan ? respon.checkPlan : ''
				}
			},
			clean() {
				if (isempty(this.nowEntity)) {
					return
				}
				this.$api.unitApi.resetSafeRunTime(this.nowEntity.id, respon => {
					this.$store.unitStore.commit("cleanUnitDefects")
					this.setValue(respon)
				})
			},
			query() {
				if (isempty(this.nowEntity)) {
					return
				}
				let res = this.$store.unitStore.getters.getUnitDefectById(this.nowEntity.id)
				if (isempty(res)) {
					this.$api.unitApi.getUnitInfo(this.nowEntity.id, respon => {
						this.setValue(respon)
					})
				} else {
					this.setValue(res)
				}

			},
			backPath(data) {
				var dataPath = this.$store.resourcesStore.state.filePath + data
				return {
					'background-image': 'url(' + dataPath + ')'
				}
			}
		}
	}
</script>

<style scoped>
	.rightBody .wedoButton-body {
		width: 1rem;
	}

	.rightBody {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.defectPage {
		width: 95%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		height: calc(95% - .37rem);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		margin: 0 auto;
		margin-top: .1rem;
	}

	.defect-group {
		width: 100%;
		display: flex;
		height: .5rem;
		align-items: center;
	}

	.defect-item {
		height: .3rem;
		margin-left: .15rem;
	}

	.defect-item span {
		margin-left: .1rem;
		height: .3rem;
		font-size: .15rem;
		line-height: .3rem;
		color: #e2e2e1;
	}

	.defect-item input {
		padding-left: .1rem;
		margin-left: .1rem;
		border: 1px solid #000000;
		height: .2rem;
		font-size: .15rem;
		line-height: .2rem;
	}

	.label-class {
		padding-left: .1rem;
		font-size: .2rem;
		color: #e2e2e1;
	}

	.text-class {
		margin-top: .1rem;
		width: 50%;
		height: 50%;
		outline: none;
		background-color: rgb(0, 0, 0, 0);
		border: .01rem solid #697a98;
		color: #e2e2e1;
		margin-left: .2rem;
	}

	.defectPage input {
		outline: none;
		background-color: rgb(0, 0, 0, 0);
		border: .01rem solid #697a98;
		color: #e2e2e1;
	}
</style>
